import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig =  {
  apiKey: "AIzaSyAUPJKKQ7r8i9aQLJq40yKWloPGSQctrCo",
  authDomain: "myskoolpushnotifications.firebaseapp.com",
  projectId: "myskoolpushnotifications",
  storageBucket: "myskoolpushnotifications.firebasestorage.app",
  messagingSenderId: "457003238957",
  appId: "1:457003238957:web:3c9e8a3a838c3216435aa4",
  measurementId: "G-EPN1PHM5B0"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
